"use client";

import { Slider as SliderPrimitive } from "@base-ui/react/slider";

import { cx } from "../../cx";
import styles from "./slider.module.css";

type SliderProps = Omit<SliderPrimitive.Root.Props, "className"> & {
  className?: string;
  /** One accessible name per thumb, in thumb order. */
  thumbLabels: readonly string[];
};

/** A single or range slider: one thumb per entry in `thumbLabels`. */
function Slider({ className, thumbLabels, ...props }: SliderProps) {
  return (
    <SliderPrimitive.Root
      data-tui=""
      data-slot="slider"
      className={cx(styles.root, className)}
      {...props}
    >
      <SliderPrimitive.Control className={styles.control}>
        <SliderPrimitive.Track className={styles.track}>
          <SliderPrimitive.Indicator className={styles.indicator} />
          {thumbLabels.map((label, index) => (
            <SliderPrimitive.Thumb
              key={label}
              index={index}
              aria-label={label}
              className={cx(styles.thumb, "tui-focus-within")}
            />
          ))}
        </SliderPrimitive.Track>
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  );
}

export { Slider };
